import React from "react";

import starOrange from "images/star-small-orange.svg";
import starGrey from "images/star-small-grey.svg";

export default function Star({ starOn, large }) {
    return <img src={starOn ? starOrange : starGrey} className={"Star"} width={large ? "21px" : "16px"} height={large ? "21px" : "16px"} alt={starOn ? "star" : ""} />;
}



// WEBPACK FOOTER //
// ./src/components/Star.js